import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const multiTenancyRouter: RouteConfig = {
  path: "/multi-tenancy",
  name: "MultiTenancy",
  component: Layout,
  meta: {
    title: "学校管理",
    icon: "multi-tenancy",
    permission: "Pages.MultiTenancy"
  },
  children: [
    {
      path: "tenant",
      name: "Tenant",

      component: () =>
        import(
          /* webpackChunkName: "tenant" */ "@/views/multi-tenancy/tenant/index.vue"
        ),
      meta: {
        title: "学校管理",
        permission: "Pages.MultiTenancy.Tenant",
        icon: "multi-tenancy"
      }
    },
    {
      path: "tenant/create/:id",
      name: "CreateTenant",
      component: () =>
        import(
          /* webpackChunkName: "create-tenant" */ "@/views/multi-tenancy/tenant/create-tenant.vue"
        ),
      meta: {
        title: "添加学校",
        hidden: true,
        permission: "Pages.MultiTenancy.Tenant.Create"
      }
    },
    {
      path: "tenant/update/:id",
      name: "UpdateTenant",
      component: () =>
        import(
          /* webpackChunkName: "update-tenant" */ "@/views/multi-tenancy/tenant/update-tenant.vue"
        ),
      meta: {
        title: "修改学校",
        hidden: true,
        permission: "Pages.MultiTenancy.Tenant.Update"
      }
    },
    {
      path: "customizedPush",
      name: "CustomizedPush",

      component: () =>
        import(
          /* webpackChunkName: "tenant" */ "@/views/customizedPush/index.vue"
        ),
      meta: {
        title: "自定义推送",
        // permission: "Pages.MultiTenancy.Tenant",
        icon: "customizedPush"
      }
    },
  ]
};

export default multiTenancyRouter;
